import * as Sentry from '@sentry/nextjs'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useTranslation } from 'next-i18next'
import toast from 'react-hot-toast'
import { downloadFileFromBlob } from 'shared/utils/file/download-file'

export const useDownloadCertificate = (
  filename: string,
): UseMutationResult<Blob, Error, string> => {
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (link: string) => {
      if (!link) {
        throw new Error('Certificate link not available')
      }

      const response = await fetch(link, {
        headers: {
          Accept: '*/*',
        },
      })

      if (!response.ok) {
        // TODO: Create new Error type for this case
        const error = new Error(
          `Certificate download failed: ${response.status} ${response.statusText}`,
        )
        ;(error as unknown as { statusCode?: number; url?: string }).statusCode = response.status
        ;(error as unknown as { statusCode?: number; url?: string }).url = link
        throw error
      }

      return response.blob()
    },

    onSuccess: blob => {
      downloadFileFromBlob(blob, filename)
    },

    onError: error => {
      Sentry.captureException(error, {
        extra: { context: 'Certificate download failed' },
      })
      toast.error(t('course.certificate.error'))
    },
  })
}
